import axios, { AxiosProgressEvent, AxiosResponse } from 'axios'
import { ResourceTypes, SingleResourceResponse, AttachmentInfo, Document } from '@vendorflow/types'
import { convertResourceToEntity } from '@vendorflow/common/lib/converters/JsonApi.converter'

import { FILER_API_URL, VERSION } from 'constants/Api.constants'
import { AUTHORIZATION_SENTINEL } from 'features/auth/Auth.constants'

const MAX_AGE = 365 * 24 * 60 * 60

export async function fetchAttachmentUsingGET(attachmentId: string): Promise<{ document: Document; href: string }> {
  const result: AxiosResponse<SingleResourceResponse<Document, ResourceTypes.DOCUMENTS>> = await axios.request({
    method: 'GET',
    url: `${FILER_API_URL}/${VERSION}/documents/${attachmentId}`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })
  const document: Document = convertResourceToEntity(result.data.data)
  const href = result.data.data.links?.contents?.href

  return { document, href: href! }
}

export async function createUploadTicketUsingPOST(
  attachmentInfo: AttachmentInfo,
  orgId: string,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<{ ticketId: string; putToUrl: string; onCompleteUrl: string; filename: string }> {
  const url = `${FILER_API_URL}/${VERSION}/uploads`
  const result: AxiosResponse<any> = await axios.request({
    method: 'POST',
    url,
    data: {
      data: {
        type: 'uploads',
        attributes: attachmentInfo,
        relationships: { workspace: { data: { type: 'workspaces', id: orgId } } },
      },
    },
    headers: { Authorization: AUTHORIZATION_SENTINEL },
    onUploadProgress,
  })
  const {
    id: ticketId,
    links: {
      putTo: { href: putToUrl },
      onComplete: { href: onCompleteUrl },
    },
    attributes: { filename },
  } = result.data.data
  return { ticketId, putToUrl, onCompleteUrl, filename }
}

export async function uploadFileUsingPut(
  putTo: string,
  file: Blob,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<void> {
  await axios.request({
    method: 'PUT',
    url: putTo,
    data: file,
    headers: {
      'Content-Type': file.type,
      'Cache-Control': `max-age=${MAX_AGE}`,
    },
    onUploadProgress,
  })
}

export async function completeUploadTicketUsingPOST(
  onComplete: string,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<void> {
  await axios.request({
    method: 'POST',
    url: onComplete,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
    onUploadProgress,
  })
}
